import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rank" }
const _hoisted_2 = { class: "slider-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "rank-badge top-highlight"
}
const _hoisted_5 = {
  key: 1,
  class: "rank-badge top-regular"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  class: "title",
  style: {"font-size":"20px"}
}
const _hoisted_9 = {
  class: "views",
  style: {"font-size":"15px"}
}

import { ref, onMounted, computed, onBeforeUnmount } from 'vue'
import axiosCt from '../../api/chart'



const slideSpeed = 0.5; // px/frame


export default /*@__PURE__*/_defineComponent({
  __name: 'YoutubeRankingSlider',
  setup(__props) {

const videoitems = ref<any[]>([]);
const currentOffset = ref(0);
const sliderRef = ref<HTMLElement | null>(null);
let timer: number | undefined;

const repeatedVideos = computed(() => {
  return [...videoitems.value, ...videoitems.value].map((video, i) => {
    const baseIndex = i % videoitems.value.length;
    return {
      ...video,
      rank: baseIndex < 11 ? baseIndex + 1 : null,
    };
  });
});


const fetchMusic = async () => {
  const response = await axiosCt.getYoutubeChart();
  videoitems.value = response.data;
};

const formatViews = (num: number) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1) + 'K';
  return num.toString();
};

const goToVideo = (url: string) => {
  window.open(url, '_blank');
};

const slide = () => {
  if (!sliderRef.value) return;

  currentOffset.value += slideSpeed;

  const totalWidth = sliderRef.value.scrollWidth / 2; // 원본 한 세트 너비 (반복된 두 세트 중 한 세트 길이)

  if (currentOffset.value >= totalWidth) {
    currentOffset.value = 0;
  }

  sliderRef.value.style.transform = `translateX(-${currentOffset.value}px)`;
};


const startSliding = () => {
  timer = window.setInterval(slide, 16);
};

const stopSliding = () => {
  if (timer) clearInterval(timer);
};

onBeforeUnmount(() => {
  stopSliding();
});

onMounted(async () => {
  await fetchMusic();
  startSliding();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"margin-bottom":"10px"} }, " 조회수 TOP 10 영상 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "sliderRef",
        ref: sliderRef,
        class: "slider-wrapper"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatedVideos.value, (video, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index + '-' + video.videoId,
            class: "slide-item",
            style: {"position":"relative"},
            onClick: ($event: any) => (goToVideo(video.videoUrl))
          }, [
            (video.rank && video.rank <= 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " TOP " + _toDisplayString(video.rank), 1))
              : (video.rank && video.rank <= 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " TOP " + _toDisplayString(video.rank), 1))
                : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: video.thumbnailUrl,
              alt: video.title,
              class: "thumbnail"
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(video.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(formatViews(video.viewCount)) + " views ", 1)
            ])
          ], 8, _hoisted_3))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})